<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M19 12.0846C19 11.5323 18.5523 11.0846 18 11.0846L11.7476 11.0846L13.3717 9.29689C13.7195 8.91399 13.7179 8.32898 13.368 7.94799L13.3133 7.88846C12.9163 7.45631 12.2343 7.45723 11.8385 7.89046L8 12.0922L11.8524 16.2833C12.2487 16.7144 12.9289 16.7143 13.3251 16.283L13.3793 16.224C13.7304 15.8418 13.7307 15.2545 13.38 14.8719L11.7419 13.0846L18 13.0846C18.5523 13.0846 19 12.6369 19 12.0846ZM9.37169 9.29689C9.71955 8.91399 9.71794 8.32898 9.36798 7.94799L9.31329 7.88846C8.91633 7.4563 8.23432 7.45723 7.83854 7.89046L4 12.0922L7.85239 16.2833C8.24867 16.7144 8.92894 16.7143 9.32508 16.283L9.37928 16.224C9.73039 15.8418 9.73071 15.2545 9.38001 14.8719L6.83226 12.0922L9.37169 9.29689Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>

</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
